import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmModalComponent, NotificationsService, PageComponent, SyslinkToolbarAction, SyslinkToolbarActionButton } from 'projects/libraries/syslink-components/src/public-api';
import { UserPermission } from '../user-permission.model';
import { UserPermissionsService } from '../user-permissions.service';

@Component({
  selector: 'app-user-permission-details',
  templateUrl: './user-permission-details.component.html',
  styleUrls: ['./user-permission-details.component.scss']
})
export class UserPermissionDetailsComponent extends PageComponent implements OnInit {

  public element: UserPermission = new UserPermission();

  @ViewChild('deleteConfirm') deleteConfirm: ConfirmModalComponent = new ConfirmModalComponent;

  constructor(
    private ngxUiLoaderService: NgxUiLoaderService,
    public override activatedRoute: ActivatedRoute,
    private userPermissionsService: UserPermissionsService
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.activatedRoute.data.subscribe(async ({ element }) => {
      this.ngxUiLoaderService.start();
      this.element = element;
      await this.refreshElement();
      this.ngxUiLoaderService.stop();
    });
  }
  public refreshElement() {
    this.updateBreadCrumb(this.element.Code);
    this.updateToolbar();
  }
  public updateToolbar() {
    this.toolbarActions = [];
    this.toolbarActions.push(new SyslinkToolbarActionButton({ icon: "save", text: "Save", onClick: () => this.onSavebtnClicked(), hotkey: 'control.s' }));
    if (!this.element.Id) return;
    this.toolbarActions.push(new SyslinkToolbarActionButton({ icon: "trash", text: "Delete", onClick: () => this.onPermissionDeleteBtn() }));
  }

  // Save btn
  // --------
  public async onSavebtnClicked() {

    if (this.element.Code == "" ) {
      NotificationsService.sendErrorMessage("Code cannot be empty");
      return;
    }
    if (this.element.Id) {
      await this.userPermissionsService.update(this.element.Id, this.userPermissionsService.format(this.element));
    } else {
      var element = await this.userPermissionsService.insert(this.userPermissionsService.format(this.element));
      this.goToUrl('../' + element.Id);
    }
    NotificationsService.sendSuccess("Record updated");
  }

  // User delete
  // --------------
  public onPermissionDeleteBtn() {
    this.deleteConfirm.open();
  }
  public async permissionDelete() {
    this.deleteConfirm.close();
    if (!this.element?.Id) return;
    await this.userPermissionsService.remove(this.element.Id);
    NotificationsService.sendInfo('Record deleted');
    this.goToUrl('../');
  }

}
